import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import { Box } from '@mui/system';
import LoaderDialog from './LoaderDialog';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentDialog = ({open, handleClose, handlePayment}) => {
  const [paymentMode, setPaymentMode] = React.useState("Cash");
  const [paymentRefNum, setPaymentRefNum] = React.useState("");
  const [customerMobile, setCustomerMobile] = React.useState("");
  const [disabled, setDisabled] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const handlePaymentModeChange = (event) => {
    setPaymentMode(event.target.value);
  };

  React.useEffect(() => {
    const validate = async() => {
      setDisabled((paymentMode === "Card" || paymentMode === "UPI") && paymentRefNum.trim().length === 0)
    };
    validate();
  },[paymentRefNum, paymentMode]);

  const paymentHandle = async() => {
    setLoading(true)
    handlePayment(paymentMode, paymentRefNum, customerMobile, false, "")
    resetField();
  };
  const handleCloseDialog = async() => {
    handleClose();
    resetField();
  };
  const resetField = async() => {
    setPaymentMode("Cash")
    setCustomerMobile("")
    setPaymentRefNum("")
    setLoading(false)
  };
  return (
    <div>
      <Dialog open={open} onClose={handleCloseDialog} TransitionComponent={Transition} sx={{width: "100vw"}}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseDialog}><CloseIcon /></IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Payment</Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField select label="Mode" value={paymentMode} onChange={handlePaymentModeChange} variant="standard" SelectProps={{native: true}} fullWidth>
                <option key="Cash" value="Cash">Cash</option>
                <option key="Card" value="Card">Card</option>
                <option key="UPI" value="UPI">UPI</option>
              </TextField>
            </Grid>
            {(paymentMode === "Card" || paymentMode === "UPI") && <Grid item xs={12}><TextField label="Reference Number" variant="standard" fullWidth value={paymentRefNum} onChange={(event)=> setPaymentRefNum(event.target.value)}/></Grid>}
            <Grid item xs={12}><TextField label="Customer Mobile Number" variant="standard" fullWidth value={customerMobile} onChange={(event)=> setCustomerMobile(event.target.value)}/></Grid>
            <Grid item xs={12}>
              <Button autoFocus variant="contained" disabled={disabled || loading} onClick={paymentHandle} fullWidth>Payment</Button>
              <LoaderDialog open={loading} title="Processing Payment ..."/>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default PaymentDialog
